import StoreFilterContainer from "../components/StoreFilterContainer";

/**
 * React component for the Wheel Store filter page.
 * Renders the StoreFilterContainer with type set to "wheel".
 */
export default function MstWheelStore() {
  return <StoreFilterContainer type="wheel" />;
}
